
// ---------------------------------------------------------------------------
// Money format handler — supports all currencies via Intl.NumberFormat
// ---------------------------------------------------------------------------
// money_format 示例：
//   "${{amount}}"                              → 美元 (USD)
//   "€{{amount}}"                              → 欧元 (EUR)
//   "{{amount}} ¥"                             → 日元 (JPY)
//   "{{amount_with_comma_separator}} €"        → 欧式格式欧元
//   "{{amount_no_decimals}} kr"                → 北欧货币（整数）
//   "CHF {{amount}}"                           → 瑞士法郎
//   Uses Intl.NumberFormat when currency_code is set (recommended)
// ---------------------------------------------------------------------------
// Shopify.money_format = "EUR{{amount_with_comma_separator}}";
// Shopify.currency_code = "EUR"; // 设置当前货币代码（ISO 4217），如 "EUR", "JPY", "GBP" 等



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "EUR{{amount_with_comma_separator}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};